<template>
<div>
  <div class="locale-textarea" v-for="l in locales">
    <textarea class="form-control" type="text"
      :id="`input-locale-${id}-${l}`"
      :maxlength="attrs.maxlength"
      :placeholder="`${attrs.placeholder} (${l})`"
      :disabled="attrs.disabled"
      :rows="attrs.rows"
      :autofocus="attrs.autofocus"
      :value="value[l]"
      v-show="l === currentLocale"
      @blur="validate"
      @input="setValue(l, $event)">
    </textarea>
  </div>
</div>
</template>

<script>
// Localized text input component
// Allow the user the input a text in multiple languages.
// Render a textarea for each supported locale and handle switching between them.

export default {
  props: ['value', 'locales', 'attrs', 'currentLocale'],
  data: function () {
    return {
      id: this._uid
    }
  },
  watch: {
    value: {
      handler: function () {
        this.validate()
      },
      deep: true
    },
    currentLocale: function (l, previousLocale) {
      this.$nextTick(() => {
        this.validate()
      })
    }
  },
  methods: {
    setValue: function (lang, event) {
      let copy = Object.assign({}, this.value)
      copy[lang] = event.target.value
      this.$emit('input', copy)
    },
    validate: function () {
      for (let l of this.locales) {
        this.clearCustomValidity(this.getElementForLocale(l))
      }
      if (this.attrs.required) {
        if (!Object.keys(this.value).some((l) => {
          return this.value[l]
        })) {
          this.addCustomValidity(this.$t('language_input_required'))
        }
      }
    },
    clearCustomValidity: function (el) {
      if (el.validity.customError) {
        el.setCustomValidity('')
      }
    },
    addCustomValidity: function (message) {
      this.getActiveElement().setCustomValidity(message)
    },
    getElementForLocale: function (l) {
      return document.getElementById(`input-locale-${this.id}-${l}`)
    },
    getActiveElement: function () {
      return this.getElementForLocale(this.currentLocale)
    }
  }
}
</script>



// WEBPACK FOOTER //
// InputLocalizedText.vue?7cf04bc9